"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAbilityAnimation = void 0;
const core_1 = require("../vfx/core");
const TimeInterval_1 = require("../vfx/TimeInterval");
function DefaultArgs(animatedId, abilityKey, fallback) {
    return {
        delay: new core_1.DelayVfxStepArgs(new TimeInterval_1.AbilityAnimationVfxTimeInterval(animatedId, abilityKey, fallback)),
        onAnimated: () => { },
    };
}
function applyAbilityAnimation(args) {
    args = {
        ...DefaultArgs(args.animatedId, args.abilityKey, args.fallback),
        ...args
    };
    const { animatedId, abilityKey, fallback, delay, onAnimated } = args;
    let { sequence } = args;
    sequence = args.sequence.pushSequence("parallel")
        .push(new core_1.AnimateCharacterAbilityVfxStepArgs(animatedId, abilityKey, fallback))
        // don't add a character sfx to avoid that and the ability playing at once. client should use the from arg provided here
        .push(new core_1.AbilitySoundEffectVfxStepArgs(animatedId, abilityKey, "start", fallback))
        .pushSequence("sequential")
        .push(delay || new core_1.NoneVfxStepArgs())
        .pushSequence("parallel");
    onAnimated(sequence);
}
exports.applyAbilityAnimation = applyAbilityAnimation;
